var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickIcon = function SvgPickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1AA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.116 3.735a.9.9 0 0 1 1.768 0l.946 5a1.8 1.8 0 0 0 1.434 1.435l5.001.946a.9.9 0 0 1 0 1.768l-5 .946a1.8 1.8 0 0 0-1.435 1.434l-.946 5.001a.9.9 0 0 1-1.768 0l-.946-5a1.8 1.8 0 0 0-1.434-1.435l-5.001-.946a.9.9 0 0 1 0-1.768l5-.946a1.8 1.8 0 0 0 1.435-1.434z"
  })));
};
export default SvgPickIcon;